export default "__VITE_ASSET__D3qAg4pT__"